import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const caseStudies = [
  {
    tag: "Healthcare",
    title: "AI-Powered Patient Flow Optimization",
    desc: "Reduced average wait times by 35% and improved bed utilization by 22% at a multi-specialty hospital in Bihar using predictive analytics.",
    metric: "35%",
    metricLabel: "Wait Time Reduction",
    span: "md:col-span-12",
  },
];

export default function CaseStudies() {
  return (
    <section id="case-studies" data-testid="case-studies-section" className="py-24 md:py-32 relative bg-[#faf7f2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
            className="text-xs font-bold uppercase tracking-[0.2em] text-[#2a9d8f] mb-4">Proven Results</motion.p>
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#2d2926]" style={{ fontFamily: 'Fraunces, serif' }}>
            Case <span className="gradient-text">Studies</span>
          </motion.h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {caseStudies.map((cs, i) => (
            <motion.div key={cs.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              className={`${cs.span} group`} data-testid={`case-study-card-${i}`}>
              <div className="warm-card p-8 h-full">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-xs font-bold uppercase tracking-widest text-[#2a9d8f]">{cs.tag}</span>
                  <ArrowUpRight className="w-5 h-5 text-[#d5cec5] group-hover:text-[#2a9d8f] transition-colors" />
                </div>
                <h3 className="text-xl font-semibold text-[#2d2926] mb-3" style={{ fontFamily: 'Fraunces, serif' }}>{cs.title}</h3>
                <p className="text-sm text-[#5c564e] leading-relaxed mb-6">{cs.desc}</p>
                <div className="pt-4 border-t border-[#ebe5dc]">
                  <p className="text-3xl font-bold text-[#2a9d8f]" style={{ fontFamily: 'Fraunces, serif' }}>{cs.metric}</p>
                  <p className="text-xs text-[#8a8078] mt-1">{cs.metricLabel}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
